export const API_EXTERNAL_ENDPOINT = 'deals/home'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/deals/home'
